<template>
  <div id="app">
    <component :is="layout"></component>
  </div>
</template>

<script>
//Définition du layout par defaut
const default_layout = "app-layout";
export default {
  name: "app",
  computed: {
    layout() {
      //On lit l'attribut meta du route actuel pour obtenir le layout, si l'attribut meta n'est pas présent on affiche le layout par defaut
      return this.$route.meta.layout || default_layout;
    },
  },
};
</script>
<style>
.pointer-table {
  cursor: pointer;
}

.pointer-telechargement {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}

.pointer {
  cursor: pointer;
}

.pointer:hover {
  cursor: pointer;
  color: grey;
}

.transparentColor {
  color: #11ffee00;
}

.iconLeftMargin {
  margin-left: 12px;
}

.error-text {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
</style>
